<template>
  <div class="mt-4">
    <v-card class="mx-auto" max-width="95%" elevation="2">
      <v-toolbar dark>
        <v-toolbar-title>단타의 신 · Debug 테스트</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>

      <v-tabs v-model="debugTab" color="primary" class="mt-0">
        <v-tab><v-icon left small>mdi-gamepad-variant</v-icon>참여 테스트</v-tab>
        <v-tab><v-icon left small>mdi-account-arrow-right</v-icon>참여테스트(개별)</v-tab>
        <v-tab><v-icon left small>mdi-cancel</v-icon>라운드 강제 무효</v-tab>
        <v-tab><v-icon left small>mdi-clipboard-list-outline</v-icon>Bet Orders 조회</v-tab>
        <v-tab><v-icon left small>mdi-flag-checkered</v-icon>강제 정산</v-tab>
      </v-tabs>
      <v-divider></v-divider>

      <v-tabs-items v-model="debugTab">
        <!-- 탭1: 참여 테스트 -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="info" class="mb-4 body-2">
              유저 ID 리스트를 입력하면 진행중인 게임에 랜덤 방향(UP/DOWN)으로 베팅을 시뮬레이션합니다.
              베팅 금액은 게임 템플릿의 판돈(bet_amount) 설정을 따릅니다.
            </v-alert>

            <v-row>
              <!-- 왼쪽: 입력 영역 -->
              <v-col cols="5">
                <v-select
                  v-model="betTest.gameId"
                  :items="activeGames"
                  item-text="label"
                  item-value="game_id"
                  label="게임 선택 (진행중)"
                  outlined
                  dense
                  :loading="loadingGames"
                  @focus="loadActiveGames"
                ></v-select>

                <v-select
                  v-model="betTest.appKey"
                  :items="mediaList"
                  item-text="label"
                  item-value="app_key"
                  label="매체 선택"
                  outlined
                  dense
                  :loading="loadingMedia"
                  @focus="loadMediaList"
                ></v-select>

                <v-textarea
                  v-model="betTest.userIds"
                  label="유저 ID 리스트 (줄바꿈 구분)"
                  outlined
                  dense
                  rows="8"
                  placeholder="testuser001&#10;testuser002&#10;testuser003"
                ></v-textarea>

                <v-btn
                  color="primary"
                  block
                  :loading="betTest.running"
                  :disabled="!canRunBetTest"
                  @click="runBetTest"
                >
                  <v-icon left>mdi-play</v-icon>
                  참여 실행 ({{ parsedUserIds.length }}명)
                </v-btn>
              </v-col>

              <!-- 오른쪽: 결과 영역 -->
              <v-col cols="7">
                <div class="d-flex align-center mb-2" v-if="betTest.results.length > 0">
                  <span class="text-subtitle-2 font-weight-bold">
                    실행 결과 — 성공: {{ betTest.successCount }} / 실패: {{ betTest.failCount }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn x-small outlined @click="betTest.results = []">초기화</v-btn>
                </div>

                <v-data-table
                  :headers="betResultHeaders"
                  :items="betTest.results"
                  :items-per-page="20"
                  dense
                  class="elevation-0"
                  no-data-text="실행 결과가 없습니다."
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      x-small
                      :color="item.status === 'success' ? 'green' : 'red'"
                      text-color="white"
                    >
                      {{ item.status }}
                    </v-chip>
                  </template>
                  <template v-slot:item.direction="{ item }">
                    <v-chip
                      x-small
                      :color="item.direction === 'up' ? 'blue' : 'orange'"
                      text-color="white"
                    >
                      {{ item.direction === 'up' ? 'UP' : 'DOWN' }}
                    </v-chip>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- 탭2: 참여테스트(개별) -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="info" class="mb-4 body-2">
              유저 ID 리스트를 입력하면 각 유저마다 UP / DOWN 버튼이 생성됩니다.
              원하는 버튼을 누르면 해당 유저만 선택한 방향으로 진행중인 게임에 베팅합니다.
            </v-alert>

            <v-row>
              <!-- 왼쪽: 입력 영역 -->
              <v-col cols="5">
                <v-select
                  v-model="betTestSingle.gameId"
                  :items="activeGames"
                  item-text="label"
                  item-value="game_id"
                  label="게임 선택 (진행중)"
                  outlined
                  dense
                  :loading="loadingGames"
                  @focus="loadActiveGames"
                ></v-select>

                <v-select
                  v-model="betTestSingle.appKey"
                  :items="mediaList"
                  item-text="label"
                  item-value="app_key"
                  label="매체 선택"
                  outlined
                  dense
                  :loading="loadingMedia"
                  @focus="loadMediaList"
                ></v-select>

                <v-textarea
                  v-model="betTestSingle.userIds"
                  label="유저 ID 리스트 (줄바꿈 구분)"
                  outlined
                  dense
                  rows="8"
                  placeholder="testuser001&#10;testuser002&#10;testuser003"
                ></v-textarea>

                <div class="d-flex">
                  <v-btn
                    color="grey"
                    outlined
                    block
                    :disabled="!canRunSingleBetTest"
                    @click="prepareSingleList"
                  >
                    <v-icon left>mdi-format-list-bulleted</v-icon>
                    리스트 준비 ({{ parsedUserIdsSingle.length }}명)
                  </v-btn>
                </div>
              </v-col>

              <!-- 오른쪽: 개별 실행 리스트 -->
              <v-col cols="7">
                <div class="d-flex align-center mb-2" v-if="betTestSingle.entries.length > 0">
                  <span class="text-subtitle-2 font-weight-bold">
                    개별 실행 — 성공: {{ betTestSingle.successCount }} / 실패: {{ betTestSingle.failCount }}
                  </span>
                  <v-spacer></v-spacer>
                  <v-btn x-small outlined class="mr-2" @click="resetSingleResults">결과 초기화</v-btn>
                  <v-btn x-small outlined @click="betTestSingle.entries = []">리스트 비우기</v-btn>
                </div>

                <v-data-table
                  :headers="singleBetHeaders"
                  :items="betTestSingle.entries"
                  :items-per-page="20"
                  dense
                  class="elevation-0"
                  no-data-text="좌측에서 리스트를 준비하세요."
                >
                  <template v-slot:item.action="{ item }">
                    <!-- sports/manual: 동적 N choices 버튼. 가격형: UP/DOWN fallback. -->
                    <v-btn
                      v-for="(c, idx) in singleBetChoiceButtons"
                      :key="c.code"
                      x-small
                      :color="c.color"
                      dark
                      :class="idx < singleBetChoiceButtons.length - 1 ? 'mr-1' : ''"
                      :loading="item.running && item.direction === c.code"
                      :disabled="!canRunSingleBetTest || item.running"
                      @click="runSingleBetTest(item, c.code)"
                    >
                      <v-icon v-if="c.icon" left x-small>{{ c.icon }}</v-icon>{{ c.label }}
                    </v-btn>
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status"
                      x-small
                      :color="item.status === 'success' ? 'green' : 'red'"
                      text-color="white"
                    >
                      {{ item.status }}
                    </v-chip>
                    <span v-else class="text-caption grey--text">대기</span>
                  </template>
                  <template v-slot:item.direction="{ item }">
                    <v-chip
                      v-if="item.direction"
                      x-small
                      :color="item.direction === 'up' ? 'blue' : 'orange'"
                      text-color="white"
                    >
                      {{ item.direction === 'up' ? 'UP' : 'DOWN' }}
                    </v-chip>
                    <span v-else>-</span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- 탭3: 라운드 강제 무효 -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="warning" class="mb-4 body-2">
              선택한 게임의 진행중 라운드를 무효(cancel)시킵니다.
              모든 베팅은 환불 처리되며, 매체에 <strong>round_canceled</strong> + <strong>bet_canceled</strong> 콜백이 발송되고 S3 정산 JSON 도 업로드됩니다.
              이미 settled / cancelled 상태인 라운드는 멱등적으로 스킵됩니다.
            </v-alert>

            <v-row>
              <!-- 왼쪽: 게임 선택 + 라운드 정보 + 액션 -->
              <v-col cols="6">
                <v-select
                  v-model="roundCancel.gameId"
                  :items="activeGames"
                  item-text="label"
                  item-value="game_id"
                  label="게임 선택 (진행중)"
                  outlined
                  dense
                  :loading="loadingGames"
                  @focus="loadActiveGames"
                ></v-select>

                <div class="d-flex align-center mb-3">
                  <v-btn
                    color="primary"
                    small
                    outlined
                    :loading="roundCancel.loading"
                    :disabled="!roundCancel.gameId"
                    @click="loadCurrentRound"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    진행 라운드 갱신
                  </v-btn>

                  <v-checkbox
                    v-model="roundCancel.autoRefresh"
                    label="3초마다 자동갱신"
                    dense
                    hide-details
                    class="ml-3 mt-0"
                    @change="onToggleAutoRefresh"
                  ></v-checkbox>
                </div>

                <v-divider class="mb-3"></v-divider>

                <!-- 진행중 라운드 정보 카드 -->
                <v-card outlined class="pa-3 mb-3" v-if="roundCancel.round">
                  <div class="d-flex align-center mb-2">
                    <span class="text-subtitle-2 font-weight-bold">진행 라운드</span>
                    <v-spacer></v-spacer>
                    <v-chip x-small :color="roundStatusColor" text-color="white">
                      {{ roundCancel.round.status }}
                    </v-chip>
                  </div>

                  <table class="round-info-table">
                    <tr><th>round_id</th><td>{{ roundCancel.round.round_id }}</td></tr>
                    <tr><th>회차</th><td>#{{ roundCancel.round.round_number }}</td></tr>
                    <tr><th>게임</th><td>{{ roundCancel.round.game_title }} ({{ roundCancel.round.game_symbol }})</td></tr>
                    <tr><th>시작</th><td>{{ formatDateTime(roundCancel.round.started_at) }}</td></tr>
                    <tr><th>마감</th><td>{{ formatDateTime(roundCancel.round.bet_closed_at) || '-' }}</td></tr>
                    <tr><th>참여자</th><td>{{ roundCancel.round.total_players }}명 (UP {{ roundCancel.round.up_players }} / DOWN {{ roundCancel.round.down_players }})</td></tr>
                    <tr><th>총 베팅</th><td>{{ formatNumber(roundCancel.round.total_bet_amount) }}원</td></tr>
                    <tr><th>UP / DOWN</th><td>{{ formatNumber(roundCancel.round.up_bet_amount) }} / {{ formatNumber(roundCancel.round.down_bet_amount) }}원</td></tr>
                    <tr><th>start_price</th><td>{{ roundCancel.round.start_price != null ? roundCancel.round.start_price : '-' }}</td></tr>
                  </table>
                </v-card>

                <v-alert
                  dense
                  text
                  type="info"
                  v-if="roundCancel.gameId && !roundCancel.round && !roundCancel.loading && roundCancel.lastFetchedAt"
                  class="mb-3"
                >
                  진행중인 라운드가 없습니다.
                </v-alert>

                <v-text-field
                  v-model="roundCancel.reason"
                  label="취소 사유 (reason — 콜백/로그/round_settlements 에 기록)"
                  hint="예: manual, debug_test, MAINTENANCE"
                  persistent-hint
                  outlined
                  dense
                ></v-text-field>

                <v-btn
                  color="red darken-1"
                  dark
                  block
                  class="mt-3"
                  :loading="roundCancel.cancelling"
                  :disabled="!canCancelRound"
                  @click="confirmCancelRound"
                >
                  <v-icon left>mdi-cancel</v-icon>
                  라운드 강제 무효화 실행
                </v-btn>
              </v-col>

              <!-- 오른쪽: 실행 결과 -->
              <v-col cols="6">
                <div class="d-flex align-center mb-2">
                  <span class="text-subtitle-2 font-weight-bold">실행 결과</span>
                  <v-spacer></v-spacer>
                  <v-btn x-small outlined v-if="roundCancel.result || roundCancel.errMsg" @click="resetCancelResult">
                    초기화
                  </v-btn>
                </div>

                <v-alert dense text type="error" v-if="roundCancel.errMsg" class="mb-3">
                  {{ roundCancel.errMsg }}
                </v-alert>

                <v-card outlined class="pa-3" v-if="roundCancel.result">
                  <div class="text-subtitle-2 mb-2 success--text">
                    <v-icon left small color="success">mdi-check-circle</v-icon>
                    무효화 완료
                  </div>
                  <table class="round-info-table">
                    <tr><th>round_id</th><td>{{ roundCancel.result.round_id }}</td></tr>
                    <tr><th>reason</th><td>{{ roundCancel.result.reason }}</td></tr>
                    <tr><th>환불 베팅</th><td>{{ roundCancel.result.refunded }}건</td></tr>
                    <tr><th>총 환불액</th><td>{{ formatNumber(roundCancel.result.total_payout) }}원</td></tr>
                    <tr><th>매체 처리수</th><td>{{ roundCancel.result.media_count }}개</td></tr>
                  </table>

                  <v-divider class="my-3"></v-divider>
                  <div class="text-caption grey--text">
                    매체 별로 <code>round_canceled</code> + <code>bet_canceled</code> 콜백이 송신되었습니다.
                    각 매체의 callback_logs / S3 정산 JSON 업로드 결과는 Service_DT_Back 로그에서 확인하세요.
                  </div>
                </v-card>

                <v-card outlined class="pa-3" v-else>
                  <div class="text-caption grey--text text-center py-6">
                    좌측에서 게임을 선택하고 무효화를 실행하면 결과가 여기에 표시됩니다.
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- 탭4: Bet Orders 조회 -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="info" class="mb-4 body-2">
              <strong>bet_orders</strong> 테이블의 베팅 주문(요청 단위) 추적 화면. 콜백 발송 상태(`final_callback_sent_at`)와 시도 횟수까지 함께 표시.
              row 더블클릭 → 매 시도(10초 × 3회) 의 raw HTTP 응답을 모달로 확인.
            </v-alert>

            <!-- 필터 영역 -->
            <v-row dense>
              <v-col cols="2">
                <v-select
                  v-model="betOrders.filters.game_id"
                  :items="[{ label:'(전체)', game_id:null }, ...activeGames]"
                  item-text="label"
                  item-value="game_id"
                  label="게임"
                  outlined dense
                  hide-details
                  @focus="loadActiveGames"
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="betOrders.filters.status"
                  :items="betOrderStatusOptions"
                  label="상태"
                  outlined dense
                  hide-details
                  clearable
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="betOrders.filters.app_key"
                  :items="[{ label:'(전체)', app_key:null }, ...mediaList]"
                  item-text="label"
                  item-value="app_key"
                  label="매체"
                  outlined dense
                  hide-details
                  @focus="loadMediaList"
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-text-field
                  v-model="betOrders.filters.user_id"
                  label="유저 ID"
                  outlined dense
                  hide-details
                  clearable
                  placeholder="testuser001"
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="betOrders.filters.since"
                  :items="sinceOptions"
                  label="기간"
                  outlined dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="betOrders.filters.limit"
                  :items="[50, 100, 200, 500]"
                  label="LIMIT"
                  outlined dense
                  hide-details
                ></v-select>
              </v-col>
            </v-row>

            <div class="d-flex align-center mt-3 mb-3">
              <v-btn color="primary" small :loading="betOrders.loading" @click="loadBetOrders">
                <v-icon left small>mdi-refresh</v-icon>조회
              </v-btn>
              <v-checkbox
                v-model="betOrders.autoRefresh"
                label="5초마다 자동갱신"
                dense
                hide-details
                class="ml-3 mt-0"
                @change="onToggleBetOrdersRefresh"
              ></v-checkbox>
              <v-spacer></v-spacer>
              <span class="text-caption grey--text">{{ betOrdersLastFetchedLabel }}</span>
            </div>

            <!-- 요약: status 별 카운트 -->
            <v-row dense v-if="betOrders.summary">
              <v-col v-for="(cnt, s) in betOrders.summary.by_status" :key="s" cols="auto">
                <v-chip
                  small
                  :color="statusColor(s)"
                  text-color="white"
                  class="mr-1"
                >
                  {{ s }}: {{ cnt }}
                </v-chip>
              </v-col>
              <v-col cols="auto">
                <v-chip small outlined>합계: {{ betOrdersTotal }}</v-chip>
              </v-col>
            </v-row>

            <v-alert dense text type="error" v-if="betOrders.errMsg" class="mt-3">
              {{ betOrders.errMsg }}
            </v-alert>

            <!-- 메인 테이블 -->
            <v-data-table
              :headers="betOrderHeaders"
              :items="betOrders.rows"
              :items-per-page="50"
              dense
              class="elevation-0 mt-3"
              no-data-text="조회 결과가 없습니다 (조회 버튼을 눌러주세요)"
              @click:row="openAttempts"
            >
              <template v-slot:item.status="{ item }">
                <v-chip x-small :color="statusColor(item.status)" text-color="white">
                  {{ item.status }}
                </v-chip>
              </template>
              <template v-slot:item.order_id_short="{ item }">
                <code class="text-caption">{{ shortOrderId(item.order_id) }}</code>
              </template>
              <template v-slot:item.direction="{ item }">
                <v-chip x-small :color="item.direction === 'up' ? 'blue' : 'orange'" text-color="white">
                  {{ item.direction === 'up' ? 'UP' : 'DOWN' }}
                </v-chip>
              </template>
              <template v-slot:item.amount="{ item }">
                {{ formatNumber(item.amount) }}
              </template>
              <template v-slot:item.attempts="{ item }">
                <span v-if="item.attempt_count > 0">
                  <v-icon
                    x-small
                    :color="(item.final_callback_sent_at) ? 'success' : 'warning'"
                  >{{ item.final_callback_sent_at ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
                  {{ item.last_attempt_no }}/{{ item.attempt_count }}
                </span>
                <span v-else class="grey--text">-</span>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>

        <!-- 탭5: 강제 정산 (sports/manual DEV) -->
        <v-tab-item>
          <v-card-text>
            <v-alert dense text type="warning" class="mb-4 body-2">
              <strong>sports / manual 라운드 강제 결과 입력</strong> — sports 라운드는 API-Football FT 결과 (수일~수주 대기) 로만 자동 정산되므로
              운영자가 즉시 결과 박아 라운드 마무리 가능. manual 라운드도 동일.
              <br><br>
              <strong>환경 정책</strong>:
              <br>• dev/local: 모든 schedule_type 허용 (테스트 자유)
              <br>• live: <strong>sports(event_driven) / manual 만 허용</strong>. 가격형(코인/주식)은 자동 가격 데이터 정산만 가능 — 임의 결과 박기 차단됨 (403).
            </v-alert>

            <v-row dense>
              <!-- 왼쪽: 게임 선택 + 라운드 정보 + 결과 선택 + 실행 -->
              <v-col cols="12" md="6">
                <v-select
                  v-model="forceResult.gameId"
                  :items="activeGames"
                  item-text="title"
                  item-value="game_id"
                  label="게임 선택 (진행중)"
                  outlined
                  dense
                  hide-details
                  class="mb-3"
                  :loading="loadingGames"
                ></v-select>

                <div class="d-flex align-center mb-2">
                  <v-spacer></v-spacer>
                  <v-btn x-small outlined :loading="gameRoundCacheLoading"
                    :disabled="!forceResult.gameId"
                    @click="forceResult.gameId && _fetchGameRoundInfo(forceResult.gameId)">
                    <v-icon x-small left>mdi-refresh</v-icon>
                    라운드 정보 갱신
                  </v-btn>
                </div>

                <!-- 라운드 정보 카드 -->
                <v-card v-if="forceResultRoundInfo" outlined class="pa-3 mb-3" color="grey lighten-5">
                  <div class="d-flex align-center mb-2">
                    <v-icon small left>mdi-circle-medium</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">진행 라운드</span>
                    <v-spacer></v-spacer>
                    <v-chip x-small :color="forceResultStatusColor" text-color="white">
                      {{ forceResultRoundInfo.status }}
                    </v-chip>
                  </div>
                  <table class="round-info-table">
                    <tr><th>round_id</th><td>{{ forceResultRoundInfo.round_id }}</td></tr>
                    <tr><th>round_number</th><td>{{ forceResultRoundInfo.round_number }}</td></tr>
                    <tr><th>schedule_type</th><td>{{ forceResultRoundInfo.schedule_type }}</td></tr>
                    <tr><th>template</th><td>{{ forceResultRoundInfo.template_code }}</td></tr>
                    <tr><th>started_at</th><td>{{ formatDateTime(forceResultRoundInfo.started_at) }}</td></tr>
                  </table>
                </v-card>
                <v-alert v-else-if="forceResult.gameId && !gameRoundCacheLoading" dense text type="info" class="body-2 mb-3">
                  진행중인 라운드가 없습니다. (베팅 가능 상태 라운드만 강제 정산 가능)
                </v-alert>

                <!-- choice 선택 -->
                <div v-if="forceResultChoices.length > 0" class="mb-3">
                  <div class="text-caption grey--text mb-2">
                    <v-icon x-small left>mdi-format-list-checkbox</v-icon>
                    결과 선택 (정산 시 result_direction 으로 박힘)
                  </div>
                  <v-radio-group v-model="forceResult.choiceCode" dense hide-details class="mt-0">
                    <v-radio
                      v-for="c in forceResultChoices"
                      :key="c.code"
                      :value="c.code"
                      :label="(c.label || c.code) + '   (' + c.code + ')'"
                    ></v-radio>
                  </v-radio-group>
                </div>

                <v-text-field
                  v-model="forceResult.reason"
                  label="사유 (선택)"
                  outlined dense hide-details
                  class="mb-3"
                  placeholder="dev_test_force_settle"
                ></v-text-field>

                <v-checkbox
                  v-model="forceResult.skipCallback"
                  label="콜백 발사 skip (DB 정산만, 매체사 알림 X)"
                  dense
                  hide-details
                  class="mb-3"
                ></v-checkbox>

                <v-btn
                  block color="error" dark large
                  :loading="forceResult.running"
                  :disabled="!canRunForceResult"
                  @click="forceResult.showConfirm = true"
                >
                  <v-icon left>mdi-flag-checkered</v-icon>
                  강제 정산 실행
                </v-btn>
              </v-col>

              <!-- 오른쪽: 실행 결과 -->
              <v-col cols="12" md="6">
                <v-card outlined class="pa-3" min-height="280">
                  <div class="d-flex align-center mb-3">
                    <v-icon small left>mdi-chart-line</v-icon>
                    <span class="text-subtitle-2 font-weight-bold">실행 결과</span>
                  </div>
                  <div v-if="forceResult.result">
                    <v-alert dense text type="success" class="body-2 mb-3">
                      정산 완료 — winners {{ forceResult.result.winners }} / losers {{ forceResult.result.losers }} / totalPayout {{ formatNumber(forceResult.result.totalPayout || forceResult.result.total_payout) }}원
                    </v-alert>
                    <table class="round-info-table">
                      <tr><th>round_id</th><td>{{ forceResult.result.round_id }}</td></tr>
                      <tr><th>result_direction</th><td>{{ forceResult.result.result_direction }}</td></tr>
                      <tr><th>winners</th><td>{{ forceResult.result.winners }}</td></tr>
                      <tr><th>losers</th><td>{{ forceResult.result.losers }}</td></tr>
                      <tr><th>totalPayout</th><td>{{ formatNumber(forceResult.result.totalPayout || forceResult.result.total_payout) }}</td></tr>
                    </table>
                    <div class="text-caption grey--text mt-3">
                      매체사 콜백(round_ended + bet_won/bet_lost) 발사 결과는 Service_DT_Back / callback_logs 에서 확인.
                    </div>
                  </div>
                  <v-alert v-else-if="forceResult.errMsg" dense text type="error" class="body-2">
                    {{ forceResult.errMsg }}
                  </v-alert>
                  <div v-else class="text-body-2 grey--text">
                    좌측에서 게임 + 결과 선택 후 실행하면 정산 결과가 여기에 표시됩니다.
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <!-- 강제 정산 확인 다이얼로그 -->
    <v-dialog v-model="forceResult.showConfirm" max-width="480">
      <v-card>
        <v-card-title class="error white--text">
          <v-icon left dark>mdi-alert</v-icon>
          강제 정산 실행 확인
        </v-card-title>
        <v-card-text class="pa-4 body-2">
          <p class="mb-2">
            라운드 <strong>{{ forceResultRoundInfo && forceResultRoundInfo.round_id }}</strong> 를
            <strong>{{ forceResult.choiceCode }}</strong> 결과로 즉시 정산합니다.
          </p>
          <p class="mb-2">
            - 베팅한 유저에게 즉시 포인트 지급/차감 (settled 상태로 박힘)<br>
            - skipCallback {{ forceResult.skipCallback ? '활성 — 콜백 없음' : '비활성 — 매체사에 round_ended + bet_won/lost 콜백 발사' }}<br>
            - 이후 실제 API-Football FT 결과가 들어와도 status='settled' 라 중복 정산 안 됨.
          </p>
          <p class="error--text font-weight-bold mb-0">
            이 작업은 되돌릴 수 없습니다 (취소만 가능 — 별도 cancel 호출 필요).
          </p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="forceResult.showConfirm = false">취소</v-btn>
          <v-btn color="error" dark :loading="forceResult.running" @click="executeForceResult">
            <v-icon left>mdi-flag-checkered</v-icon>강제 정산
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- bet_order attempts 모달 -->
    <v-dialog v-model="betOrderAttempts.show" max-width="900" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-history</v-icon>
          콜백 시도 이력
          <v-spacer></v-spacer>
          <code class="white--text text-caption">{{ betOrderAttempts.order_id }}</code>
        </v-card-title>
        <v-card-text style="max-height:60vh">
          <v-progress-linear v-if="betOrderAttempts.loading" indeterminate class="mt-3"></v-progress-linear>
          <v-alert v-else-if="betOrderAttempts.errMsg" type="error" dense text class="mt-3">
            {{ betOrderAttempts.errMsg }}
          </v-alert>
          <v-data-table
            v-else
            :headers="attemptHeaders"
            :items="betOrderAttempts.attempts"
            :items-per-page="20"
            dense
            class="elevation-0 mt-3"
            no-data-text="시도 이력이 없습니다."
          >
            <template v-slot:item.succeeded="{ item }">
              <v-icon small :color="item.succeeded ? 'success' : 'error'">
                {{ item.succeeded ? 'mdi-check-circle' : 'mdi-close-circle' }}
              </v-icon>
            </template>
            <template v-slot:item.created_at="{ item }">
              {{ formatDateTime(item.created_at) }}
            </template>
            <template v-slot:item.duration_ms="{ item }">
              {{ item.duration_ms != null ? item.duration_ms + 'ms' : '-' }}
            </template>
            <template v-slot:item.response_body="{ item }">
              <code class="text-caption" :title="item.response_body">{{ truncate(item.response_body, 60) }}</code>
            </template>
            <template v-slot:item.error_message="{ item }">
              <span class="text-caption red--text" v-if="item.error_message">{{ item.error_message }}</span>
              <span v-else>-</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="betOrderAttempts.show = false">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 무효화 확인 다이얼로그 -->
    <v-dialog v-model="roundCancel.showConfirm" max-width="480" persistent>
      <v-card>
        <v-card-title class="red darken-2 white--text">
          <v-icon left dark>mdi-alert</v-icon>
          라운드 강제 무효 확인
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-2">
            <strong>round_id = {{ roundCancel.round && roundCancel.round.round_id }}</strong>
            (#{{ roundCancel.round && roundCancel.round.round_number }})
            라운드를 강제 무효화합니다.
          </p>
          <p class="mb-2 body-2 red--text">
            진행한 모든 베팅이 환불되고 매체사에 콜백이 발송됩니다. 되돌릴 수 없습니다.
          </p>
          <p class="mb-0 body-2">
            reason: <code>{{ roundCancel.reason }}</code>
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="roundCancel.showConfirm = false">취소</v-btn>
          <v-btn color="red darken-2" dark :loading="roundCancel.cancelling" @click="executeCancelRound">
            무효화 실행
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

// 로컬스토리지 키 (매체별 저장)
// 스키마: { [app_key]: { userIds: string[], savedAt: string } }
const STORAGE_KEY = 'danta_debug_user_ids_by_media';

export default {
  name: 'Debug_Test',
  data() {
    return {
      debugTab: 0,

      // 게임 목록
      activeGames: [],
      loadingGames: false,

      // 매체 목록
      mediaList: [],
      loadingMedia: false,

      // 베팅 테스트 폼
      betTest: {
        gameId: null,
        appKey: null,
        userIds: '',
        running: false,
        results: [],
        successCount: 0,
        failCount: 0,
      },

      // 개별 베팅 테스트 폼
      betTestSingle: {
        gameId: null,
        appKey: null,
        userIds: '',
        entries: [],
        successCount: 0,
        failCount: 0,
      },

      // sports/manual 호환 — 선택한 게임의 진행중 라운드의 choices_snapshot 캐싱.
      // 가격형(coin/주식 등) 은 빈 배열 → 클라이언트는 'up'/'down' fallback.
      // sports (win_lose/over_under/btts/scoreline) 와 manual 은 실제 코드 목록.
      //   key: 'game:{gameId}' → { choices: [{code,label,...}], schedule_type, template_code, round_id, status }
      gameRoundCache: {},
      gameRoundCacheLoading: false,

      // 강제 정산 (탭5 — DEV 전용) — sports/manual 라운드에 임의 결과 박아 즉시 정산.
      forceResult: {
        gameId: null,
        choiceCode: '',
        reason: '',
        skipCallback: false,
        running: false,
        result: null,          // { round_id, result_direction, winners, losers, totalPayout }
        errMsg: '',
        showConfirm: false,
      },

      // 라운드 강제 무효 폼
      roundCancel: {
        gameId: null,
        loading: false,        // 진행 라운드 조회중
        round: null,           // 진행중 라운드 단건 (없으면 null)
        lastFetchedAt: null,   // 마지막 fetch 시각 (UI: "진행 라운드 없음" 안내 표시 trigger)
        reason: 'manual',      // cancellationService 에 전달 (UPPER_SNAKE 정규화됨)
        cancelling: false,     // cancel 실행중
        result: null,          // 마지막 cancel 응답
        errMsg: '',
        showConfirm: false,    // 확인 다이얼로그
        autoRefresh: false,    // 3초 폴링 옵션
        refreshTimerId: null,  // setInterval id
      },

      // bet_orders 조회 폼
      betOrders: {
        filters: {
          game_id: null,
          round_id: null,
          status: null,
          app_key: null,
          user_id: '',
          since: null,         // ISO timestamp 또는 null (서버 default 7일)
          limit: 100,
        },
        loading: false,
        rows: [],
        summary: null,         // { by_status: {...} }
        lastFetchedAt: null,
        errMsg: '',
        autoRefresh: false,
        refreshTimerId: null,
      },
      // 시도 이력 모달
      betOrderAttempts: {
        show: false,
        loading: false,
        order_id: '',
        attempts: [],
        errMsg: '',
      },
      // 상태 dropdown 옵션
      betOrderStatusOptions: [
        { text: '(전체)', value: null },
        { text: 'requested', value: 'requested' },
        { text: 'publisher_rejected', value: 'publisher_rejected' },
        { text: 'confirmed', value: 'confirmed' },
        { text: 'cancelled', value: 'cancelled' },
        { text: 'failed', value: 'failed' },
      ],
      // 기간 dropdown — value 는 ISO timestamp 문자열 또는 null
      sinceOptions: [
        { text: '최근 1시간', value: new Date(Date.now() - 1 * 3600_000).toISOString() },
        { text: '최근 24시간', value: new Date(Date.now() - 24 * 3600_000).toISOString() },
        { text: '최근 7일 (서버 default)', value: null },
        { text: '최근 30일', value: new Date(Date.now() - 30 * 24 * 3600_000).toISOString() },
      ],
      // 메인 테이블 헤더
      betOrderHeaders: [
        { text: 'order_id', value: 'order_id_short', width: '110', sortable: false },
        { text: 'status', value: 'status', width: '120', align: 'center' },
        { text: 'game', value: 'game_id', width: '60', align: 'right' },
        { text: 'round', value: 'round_id', width: '80', align: 'right' },
        { text: 'user', value: 'user_id', width: '110' },
        { text: 'dir', value: 'direction', width: '70', align: 'center' },
        { text: '금액(원)', value: 'amount', width: '90', align: 'right' },
        { text: '시도', value: 'attempts', width: '80', align: 'center', sortable: false },
        { text: '사유', value: 'reject_reason', sortable: false },
        { text: 'created_at', value: 'created_at', width: '160' },
      ],
      // attempts 모달 헤더
      attemptHeaders: [
        { text: '#', value: 'attempt_no', width: '50', align: 'center' },
        { text: 'event', value: 'event_type', width: '120' },
        { text: 'ok', value: 'succeeded', width: '50', align: 'center' },
        { text: 'status', value: 'http_status', width: '70', align: 'center' },
        { text: '소요', value: 'duration_ms', width: '80', align: 'right' },
        { text: 'response', value: 'response_body', sortable: false },
        { text: 'error', value: 'error_message', sortable: false },
        { text: 'created_at', value: 'created_at', width: '160' },
      ],

      // 결과 테이블 헤더
      betResultHeaders: [
        { text: '유저 ID', value: 'user_id', width: '200' },
        { text: '방향', value: 'direction', width: '80', align: 'center' },
        { text: '금액', value: 'amount', width: '100', align: 'right' },
        { text: '상태', value: 'status', width: '80', align: 'center' },
        { text: '에러', value: 'error', sortable: false },
      ],

      // 개별 실행 테이블 헤더
      singleBetHeaders: [
        { text: '유저 ID', value: 'user_id', width: '180' },
        { text: '실행', value: 'action', width: '180', align: 'center', sortable: false },
        { text: '방향', value: 'direction', width: '70', align: 'center' },
        { text: '금액', value: 'amount', width: '80', align: 'right' },
        { text: '상태', value: 'status', width: '70', align: 'center' },
        { text: '에러', value: 'error', sortable: false },
      ],
    };
  },
  computed: {
    // 줄바꿈으로 분리된 유저 ID 배열
    parsedUserIds() {
      return this.betTest.userIds
        .split('\n')
        .map(id => id.trim())
        .filter(id => id.length > 0);
    },
    // 실행 가능 여부
    canRunBetTest() {
      return (
        this.betTest.gameId &&
        this.betTest.appKey &&
        this.parsedUserIds.length > 0 &&
        !this.betTest.running
      );
    },
    // 개별 탭: 줄바꿈 분리된 유저 ID
    parsedUserIdsSingle() {
      return this.betTestSingle.userIds
        .split('\n')
        .map(id => id.trim())
        .filter(id => id.length > 0);
    },
    // 개별 탭: 게임/매체가 선택되어야 실행 버튼 활성화
    canRunSingleBetTest() {
      return !!(this.betTestSingle.gameId && this.betTestSingle.appKey);
    },
    // 개별 탭: 동적 N choices 버튼 배열.
    // sports/manual — 게임의 choices_snapshot 기반 (code/label/team_id/logo 활용 가능).
    // 가격형 — UP/DOWN 두 버튼 fallback.
    singleBetChoiceButtons() {
      const gameId = this.betTestSingle.gameId;
      const choices = gameId ? this._cachedChoiceObjectsFor(gameId) : [];
      if (!Array.isArray(choices) || choices.length === 0) {
        // 가격형 또는 미로드 — 기본 UP/DOWN.
        return [
          { code: 'up',   label: 'UP',   color: 'blue',   icon: 'mdi-arrow-up-bold'   },
          { code: 'down', label: 'DOWN', color: 'orange', icon: 'mdi-arrow-down-bold' },
        ];
      }
      // sports/manual — choices_snapshot 코드를 그대로 버튼화.
      // label 우선순위: c.label > c.code. 색상은 코드 hash 로 간단 분배.
      const palette = ['indigo', 'teal', 'pink', 'amber darken-2', 'green', 'red darken-2', 'purple'];
      return choices.map((c, idx) => ({
        code:  c.code,
        label: c.label || c.code,
        color: palette[idx % palette.length],
        icon:  null,
      }));
    },
    // 탭5 강제 정산 — 선택 게임의 현재 라운드 정보 (캐시에서).
    forceResultRoundInfo() {
      const gid = this.forceResult.gameId;
      if (!gid) return null;
      const e = this.gameRoundCache[String(gid)];
      if (!e || !e.round_id) return null;
      // 캐시 entry 에 게임 메타 + 라운드 메타 결합 — UI 표시용.
      // started_at 은 admin/current-round 응답에서 받지만 cache 에는 직접 안 박힘 → 별도로
      // 받기 위해 entry 에 _raw 박는 게 옵션이지만, 여기는 단순화: 캐시 entry 의 메타만 사용.
      return {
        round_id:      e.round_id,
        round_number:  e.round_number,
        status:        e.status,
        schedule_type: e.schedule_type,
        template_code: e.template_code,
        started_at:    e.started_at,
      };
    },
    // 강제 정산 — 선택 가능한 choices (가격형이면 ['up','down'] fallback).
    forceResultChoices() {
      const gid = this.forceResult.gameId;
      if (!gid) return [];
      const choices = this._cachedChoiceObjectsFor(gid);
      if (Array.isArray(choices) && choices.length > 0) {
        return choices.map(c => ({ code: c.code, label: c.label || c.code }));
      }
      // 가격형 fallback
      return [
        { code: 'up',   label: 'UP'   },
        { code: 'down', label: 'DOWN' },
      ];
    },
    canRunForceResult() {
      const r = this.forceResultRoundInfo;
      if (!r || !this.forceResult.choiceCode || this.forceResult.running) return false;
      // settler 직전 상태 (open/closed) 만 강제 정산 가능 — settled/cancelled 는 backend 가 reject.
      return r.status === 'open' || r.status === 'closed' || r.status === 'waiting' || r.status === 'finished';
    },
    forceResultStatusColor() {
      const s = (this.forceResultRoundInfo && this.forceResultRoundInfo.status) || '';
      if (s === 'open') return 'green';
      if (s === 'closed') return 'orange';
      if (s === 'settled') return 'grey';
      if (s === 'cancelled') return 'red';
      return 'blue-grey';
    },
    // 라운드 무효 — 'open' 또는 'closed' 상태에서만 의미 있음 (settled/cancelled 는 멱등 스킵)
    canCancelRound() {
      const r = this.roundCancel.round;
      if (!r || this.roundCancel.cancelling) return false;
      return r.status === 'open' || r.status === 'closed';
    },
    // 상태 chip 색상
    roundStatusColor() {
      const s = (this.roundCancel.round && this.roundCancel.round.status) || '';
      if (s === 'open') return 'green';
      if (s === 'closed') return 'orange';
      if (s === 'settled') return 'grey';
      if (s === 'cancelled') return 'red';
      return 'blue-grey';
    },
    // bet_orders 합계
    betOrdersTotal() {
      const s = this.betOrders.summary;
      if (!s || !s.by_status) return 0;
      return Object.values(s.by_status).reduce((a, b) => a + Number(b || 0), 0);
    },
    // bet_orders 마지막 조회 시각 표시
    betOrdersLastFetchedLabel() {
      // 매 5초 자동갱신에서 호출되므로 computed 보다 watch 가 적합하지만
      // 간단히 betOrders.lastFetchedAt 만 노출
      if (!this.betOrders.lastFetchedAt) return '';
      return `마지막 조회: ${this.formatDateTime(this.betOrders.lastFetchedAt)}`;
    },
  },
  watch: {
    // 매체가 바뀌면 해당 매체의 저장된 유저 ID를 자동 로드.
    // 선택 해제(null/empty)되면 textarea 비움.
    'betTest.appKey'(newAppKey) {
      if (!newAppKey) {
        this.betTest.userIds = '';
        return;
      }
      this.loadUserIdsForMedia(newAppKey);
    },
    // 개별 탭도 동일하게 매체별 저장 유저 ID 로드
    'betTestSingle.appKey'(newAppKey) {
      if (!newAppKey) {
        this.betTestSingle.userIds = '';
        return;
      }
      this.loadUserIdsForMediaSingle(newAppKey);
    },
    // 라운드 무효 탭: 게임 바뀌면 진행 라운드 자동 조회 + 직전 결과/에러 초기화
    'roundCancel.gameId'(newId) {
      this.roundCancel.round = null;
      this.roundCancel.result = null;
      this.roundCancel.errMsg = '';
      this.roundCancel.lastFetchedAt = null;
      // 게임 바뀌면 자동갱신 타이머 재기동 (autoRefresh 켜져있으면)
      this.onToggleAutoRefresh(this.roundCancel.autoRefresh);
      if (newId) {
        this.loadCurrentRound();
        this._fetchGameRoundInfo(newId); // sports/manual 호환 — choices 캐싱
      }
    },
    // 베팅 테스트 (랜덤) 탭: 게임 바뀌면 sports/manual 호환용 choices 캐싱.
    'betTest.gameId'(newId) {
      if (newId) this._fetchGameRoundInfo(newId);
    },
    // 개별 베팅 테스트 탭: 게임 바뀌면 동적 N 버튼 렌더 위해 choices 캐싱.
    'betTestSingle.gameId'(newId) {
      if (newId) this._fetchGameRoundInfo(newId);
    },
    // 강제 정산 탭: 게임 바뀌면 라운드 + choices 자동 로드 + 직전 결과 초기화.
    'forceResult.gameId'(newId) {
      this.forceResult.choiceCode = '';
      this.forceResult.result = null;
      this.forceResult.errMsg = '';
      if (newId) this._fetchGameRoundInfo(newId);
    },
  },
  mounted() {
    // 게임/매체 드롭다운은 페이지 진입 시 동시에 프리로드.
    // (유저 ID textarea는 매체 선택 전에는 빈 상태로 둔다)
    this.loadActiveGames();
    this.loadMediaList();
  },
  methods: {
    ...mapActions([
      'DANTA_GET_GAME_LIST',
      'DANTA_GET_MEDIA_LIST',
      'DANTA_RUN_BET_TEST',
      'DANTA_GET_CURRENT_ROUND',
      'DANTA_CANCEL_ROUND',
      'DANTA_GET_BET_ORDERS',
      'DANTA_GET_BET_ORDER_ATTEMPTS',
      'DANTA_DEV_FORCE_RESULT',
    ]),

    // 진행중 게임 목록 로드
    async loadActiveGames() {
      if (this.activeGames.length > 0) return;
      this.loadingGames = true;
      try {
        const res = await this.DANTA_GET_GAME_LIST({ status: 'active', page: 1, page_size: 100 });
        if (res) {
          this.activeGames = (res.game_list || res.list || []).map(g => ({
            ...g,
            label: `[${g.game_id}] ${g.title} (${g.symbol})`,
          }));
        }
      } catch (e) {
        console.error('게임 목록 로드 실패:', e);
      }
      this.loadingGames = false;
    },

    // 매체 목록 로드
    async loadMediaList() {
      if (this.mediaList.length > 0) return;
      this.loadingMedia = true;
      try {
        const res = await this.DANTA_GET_MEDIA_LIST({});
        if (res) {
          this.mediaList = (res.media_list || res || []).map(m => ({
            ...m,
            label: `${m.media_name} (${m.app_key})`,
          }));
        }
      } catch (e) {
        console.error('매체 목록 로드 실패:', e);
      }
      this.loadingMedia = false;
    },

    // 베팅 테스트 실행 — sports/manual 호환: 라운드의 choices_snapshot 가 있으면 그 code 풀에서 랜덤.
    // 가격형은 빈 배열 → 백엔드가 ['up','down'] fallback.
    async runBetTest() {
      this.betTest.running = true;
      this.betTest.results = [];
      this.betTest.successCount = 0;
      this.betTest.failCount = 0;

      try {
        // 게임 선택 후 라운드 캐싱이 안 됐으면 즉시 한 번 fetch (sports 호환용).
        if (this.betTest.gameId && !this._cachedChoicesFor(this.betTest.gameId)) {
          await this._fetchGameRoundInfo(this.betTest.gameId);
        }
        const choiceCodes = this._cachedChoicesFor(this.betTest.gameId);

        const res = await this.DANTA_RUN_BET_TEST({
          user_ids: this.parsedUserIds,
          game_id: this.betTest.gameId,
          app_key: this.betTest.appKey,
          // 빈 배열이면 백엔드가 ['up','down'] 사용.
          choice_codes: Array.isArray(choiceCodes) ? choiceCodes : [],
        });

        if (res) {
          this.betTest.results = res.results || [];
          this.betTest.successCount = res.success || 0;
          this.betTest.failCount = res.failed || 0;
        }

        // 성공 시 현재 매체 기준으로 유저 목록 로컬스토리지에 저장
        this.saveUserIdsForMedia();
      } catch (e) {
        alert('테스트 실행 실패: ' + (e.message || e));
      }

      this.betTest.running = false;
    },

    // sports/manual 호환 helper — 게임의 라운드 정보 + choices 캐싱.
    // 가격형은 choices_snapshot 빈 배열로 옴 (코드가 무시 + 백엔드 'up'/'down' fallback).
    async _fetchGameRoundInfo(gameId) {
      if (!gameId) return null;
      this.gameRoundCacheLoading = true;
      try {
        const res = await this.DANTA_GET_CURRENT_ROUND({ game_id: gameId });
        // CMS_Back 의 get_current_round 는 응답을 { round: <DT_Back.data> } 형태로 감싼다.
        const r = (res && res.round) || null;
        const choices = r && Array.isArray(r.choices_snapshot) ? r.choices_snapshot : [];
        const entry = {
          choices,
          codes: choices.map(c => c && c.code).filter(Boolean),
          schedule_type: r ? r.schedule_type : null,
          template_code: r ? r.template_code : null,
          round_id:      r ? r.round_id : null,
          status:        r ? r.status : null,
          round_number:  r ? r.round_number : null,
          started_at:    r ? r.started_at : null,
        };
        // Vue 2 reactivity — 객체 직접 set
        this.$set(this.gameRoundCache, String(gameId), entry);
        return entry;
      } catch (e) {
        console.warn('[Debug_Test] _fetchGameRoundInfo 실패:', e && e.message);
        return null;
      } finally {
        this.gameRoundCacheLoading = false;
      }
    },

    _cachedChoicesFor(gameId) {
      if (!gameId) return null;
      const e = this.gameRoundCache[String(gameId)];
      return e && Array.isArray(e.codes) ? e.codes : null;
    },

    _cachedChoiceObjectsFor(gameId) {
      if (!gameId) return [];
      const e = this.gameRoundCache[String(gameId)];
      return e && Array.isArray(e.choices) ? e.choices : [];
    },

    // 강제 정산 실행 — DANTA_DEV_FORCE_RESULT 호출 → DT_Back force-result API.
    // 성공 시 캐시된 라운드 정보 새로 fetch (status='settled' 반영).
    async executeForceResult() {
      this.forceResult.showConfirm = false;
      if (!this.canRunForceResult) return;
      const info = this.forceResultRoundInfo;
      this.forceResult.running = true;
      this.forceResult.errMsg = '';
      this.forceResult.result = null;
      try {
        const res = await this.DANTA_DEV_FORCE_RESULT({
          round_id:      info.round_id,
          choice_code:   this.forceResult.choiceCode,
          reason:        this.forceResult.reason || '',
          skip_callback: !!this.forceResult.skipCallback,
        });
        // DANTA_DEV_FORCE_RESULT 는 axios proxy 결과를 그대로 반환.
        // 응답 schema: { result: 1, data: {...} } 또는 raw data.
        const data = (res && res.data) ? res.data : res;
        this.forceResult.result = data || {};
        // 라운드 캐시 갱신 (status='settled' 반영)
        await this._fetchGameRoundInfo(this.forceResult.gameId);
      } catch (e) {
        const msg = (e && e.response && e.response.data && (e.response.data.message || JSON.stringify(e.response.data)))
          || (e && e.message)
          || String(e);
        this.forceResult.errMsg = '강제 정산 실패: ' + msg;
      } finally {
        this.forceResult.running = false;
      }
    },

    // 현재 선택된 매체(app_key)에 대한 유저 목록을 로컬스토리지에 저장
    saveUserIdsForMedia() {
      if (!this.betTest.appKey) return;
      try {
        let saved = {};
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) saved = JSON.parse(existing) || {};

        saved[this.betTest.appKey] = {
          userIds: this.parsedUserIds,
          savedAt: new Date().toISOString(),
        };

        localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
      } catch (e) {
        console.error('로컬스토리지 저장 실패:', e);
      }
    },

    // 특정 매체(app_key)의 저장된 유저 목록을 로드
    loadUserIdsForMedia(appKey) {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
          this.betTest.userIds = '';
          return;
        }
        const data = JSON.parse(raw) || {};
        const entry = data[appKey];
        if (entry && Array.isArray(entry.userIds) && entry.userIds.length > 0) {
          this.betTest.userIds = entry.userIds.join('\n');
        } else {
          this.betTest.userIds = '';
        }
      } catch (e) {
        console.error('로컬스토리지 로드 실패:', e);
        this.betTest.userIds = '';
      }
    },

    // 개별 탭: 매체별 저장된 유저 ID 로드 (textarea 채움)
    loadUserIdsForMediaSingle(appKey) {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) {
          this.betTestSingle.userIds = '';
          return;
        }
        const data = JSON.parse(raw) || {};
        const entry = data[appKey];
        if (entry && Array.isArray(entry.userIds) && entry.userIds.length > 0) {
          this.betTestSingle.userIds = entry.userIds.join('\n');
        } else {
          this.betTestSingle.userIds = '';
        }
      } catch (e) {
        console.error('로컬스토리지 로드 실패:', e);
        this.betTestSingle.userIds = '';
      }
    },

    // 개별 탭: 텍스트의 유저 ID들을 테이블로 변환
    prepareSingleList() {
      const ids = this.parsedUserIdsSingle;
      this.betTestSingle.entries = ids.map(id => ({
        user_id: id,
        running: false,
        status: '',
        direction: '',
        amount: '',
        error: '',
      }));
      this.betTestSingle.successCount = 0;
      this.betTestSingle.failCount = 0;
      this.saveUserIdsForMediaSingle();
    },

    // 개별 탭: 결과만 초기화 (리스트는 유지)
    resetSingleResults() {
      this.betTestSingle.entries.forEach(e => {
        e.running = false;
        e.status = '';
        e.direction = '';
        e.amount = '';
        e.error = '';
      });
      this.betTestSingle.successCount = 0;
      this.betTestSingle.failCount = 0;
    },

    // 개별 탭: 단일 유저를 선택한 방향(up/down)으로 베팅
    async runSingleBetTest(item, direction) {
      if (!this.canRunSingleBetTest) return;
      if (direction !== 'up' && direction !== 'down') return;
      item.running = true;
      item.status = '';
      item.error = '';
      item.direction = direction;

      try {
        const res = await this.DANTA_RUN_BET_TEST({
          user_ids: [item.user_id],
          game_id: this.betTestSingle.gameId,
          app_key: this.betTestSingle.appKey,
          direction,
        });

        const first = (res && (res.results || [])[0]) || null;
        if (first) {
          item.status = first.status;
          item.direction = first.direction || '';
          item.amount = first.amount != null ? first.amount : '';
          item.error = first.error || '';
        } else {
          item.status = 'fail';
          item.error = '응답이 비어 있습니다.';
        }

        if (item.status === 'success') this.betTestSingle.successCount++;
        else this.betTestSingle.failCount++;
      } catch (e) {
        item.status = 'fail';
        item.error = e.message || String(e);
        this.betTestSingle.failCount++;
      }

      item.running = false;
    },

    // 개별 탭: 입력한 유저 ID 리스트를 매체별로 저장
    saveUserIdsForMediaSingle() {
      if (!this.betTestSingle.appKey) return;
      try {
        let saved = {};
        const existing = localStorage.getItem(STORAGE_KEY);
        if (existing) saved = JSON.parse(existing) || {};

        saved[this.betTestSingle.appKey] = {
          userIds: this.parsedUserIdsSingle,
          savedAt: new Date().toISOString(),
        };

        localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
      } catch (e) {
        console.error('로컬스토리지 저장 실패:', e);
      }
    },

    // ──────────────────────────────────────────────
    //  라운드 강제 무효 탭
    // ──────────────────────────────────────────────

    // 진행중 라운드 단건 조회 — 폴링/수동 모두 동일 메서드 사용
    async loadCurrentRound() {
      if (!this.roundCancel.gameId) return;
      this.roundCancel.loading = true;
      this.roundCancel.errMsg = '';
      try {
        const res = await this.DANTA_GET_CURRENT_ROUND({ game_id: this.roundCancel.gameId });
        this.roundCancel.round = (res && res.round) || null;
        this.roundCancel.lastFetchedAt = new Date().toISOString();
      } catch (e) {
        // 네트워크/서버 오류는 errMsg 로 표시. round 는 직전 값 유지 (폴링 중 깜빡임 방지)
        this.roundCancel.errMsg = '진행 라운드 조회 실패: ' + (e.message || e);
      }
      this.roundCancel.loading = false;
    },

    // 자동 갱신 토글 — 게임 바뀌었을 때 / 체크박스 토글 시 모두 호출됨.
    // 켜져있고 game_id 있을 때만 setInterval 활성. 그 외엔 정리.
    onToggleAutoRefresh(on) {
      if (this.roundCancel.refreshTimerId) {
        clearInterval(this.roundCancel.refreshTimerId);
        this.roundCancel.refreshTimerId = null;
      }
      if (on && this.roundCancel.gameId) {
        this.roundCancel.refreshTimerId = setInterval(() => {
          // 진행중 cancel/조회 중이면 스킵 (요청 중복 방지)
          if (this.roundCancel.loading || this.roundCancel.cancelling) return;
          this.loadCurrentRound();
        }, 3000);
      }
    },

    // 무효화 확인 다이얼로그 표시
    confirmCancelRound() {
      if (!this.canCancelRound) return;
      this.roundCancel.errMsg = '';
      this.roundCancel.result = null;
      this.roundCancel.showConfirm = true;
    },

    // 실제 무효화 호출
    async executeCancelRound() {
      if (!this.canCancelRound) {
        this.roundCancel.showConfirm = false;
        return;
      }
      this.roundCancel.cancelling = true;
      this.roundCancel.errMsg = '';
      try {
        const res = await this.DANTA_CANCEL_ROUND({
          round_id: this.roundCancel.round.round_id,
          reason: (this.roundCancel.reason || 'manual').trim() || 'manual',
        });
        this.roundCancel.result = res || null;
        this.roundCancel.showConfirm = false;
        // 무효화 직후 라운드 상태 갱신 — status: cancelled 로 바뀌어야 정상
        await this.loadCurrentRound();
      } catch (e) {
        this.roundCancel.errMsg = '무효화 실패: ' + (e.message || e);
      }
      this.roundCancel.cancelling = false;
    },

    // 결과/에러만 초기화 (라운드 정보는 유지)
    resetCancelResult() {
      this.roundCancel.result = null;
      this.roundCancel.errMsg = '';
    },

    // ── display 포맷 헬퍼 ──
    formatNumber(n) {
      if (n == null || isNaN(n)) return '0';
      return Number(n).toLocaleString('ko-KR');
    },
    formatDateTime(ts) {
      if (!ts) return '';
      try {
        const d = new Date(ts);
        if (isNaN(d.getTime())) return ts;
        const pad = (v) => String(v).padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
      } catch (_) {
        return String(ts);
      }
    },
    truncate(s, n) {
      if (s == null) return '';
      const str = String(s);
      return str.length > n ? str.slice(0, n) + '…' : str;
    },
    shortOrderId(s) {
      // 'dt_202605_<48hex>' → 'dt_202605_<8hex>…' (라벨용 단축)
      if (!s) return '';
      const m = String(s).match(/^(dt_\d{6}_)([a-f0-9]+)$/);
      if (!m) return s;
      return `${m[1]}${m[2].slice(0, 8)}…`;
    },
    statusColor(s) {
      switch (s) {
        case 'requested':          return 'blue';
        case 'publisher_rejected': return 'amber darken-2';
        case 'confirmed':          return 'green';
        case 'cancelled':          return 'grey';
        case 'failed':             return 'red';
        default:                   return 'blue-grey';
      }
    },

    // ──────────────────────────────────────────────
    //  bet_orders 조회 탭
    // ──────────────────────────────────────────────

    async loadBetOrders() {
      this.betOrders.loading = true;
      this.betOrders.errMsg = '';
      try {
        // filters 의 null/빈문자열은 백엔드로 보낼 필요 없음
        const f = {};
        const src = this.betOrders.filters;
        if (src.game_id != null)              f.game_id  = src.game_id;
        if (src.round_id != null)             f.round_id = src.round_id;
        if (src.status)                       f.status   = src.status;
        if (src.app_key)                      f.app_key  = src.app_key;
        if (src.user_id && src.user_id.trim()) f.user_id = src.user_id.trim();
        if (src.since)                        f.since    = src.since;
        if (src.limit)                        f.limit    = src.limit;

        const res = await this.DANTA_GET_BET_ORDERS(f);
        if (res) {
          this.betOrders.rows = res.rows || [];
          this.betOrders.summary = { by_status: res.by_status || {} };
          this.betOrders.lastFetchedAt = new Date().toISOString();
        }
      } catch (e) {
        this.betOrders.errMsg = 'bet_orders 조회 실패: ' + (e.message || e);
      }
      this.betOrders.loading = false;
    },

    onToggleBetOrdersRefresh(on) {
      if (this.betOrders.refreshTimerId) {
        clearInterval(this.betOrders.refreshTimerId);
        this.betOrders.refreshTimerId = null;
      }
      if (on) {
        // 즉시 1회 조회 + 5초 간격 폴링
        this.loadBetOrders();
        this.betOrders.refreshTimerId = setInterval(() => {
          if (this.betOrders.loading) return;
          this.loadBetOrders();
        }, 5000);
      }
    },

    async openAttempts(item) {
      if (!item || !item.order_id) return;
      this.betOrderAttempts.show = true;
      this.betOrderAttempts.loading = true;
      this.betOrderAttempts.order_id = item.order_id;
      this.betOrderAttempts.attempts = [];
      this.betOrderAttempts.errMsg = '';
      try {
        const res = await this.DANTA_GET_BET_ORDER_ATTEMPTS({ order_id: item.order_id });
        this.betOrderAttempts.attempts = (res && res.attempts) || [];
      } catch (e) {
        this.betOrderAttempts.errMsg = 'attempts 조회 실패: ' + (e.message || e);
      }
      this.betOrderAttempts.loading = false;
    },
  },

  // 컴포넌트 파괴 시 자동갱신 타이머 정리 — 다른 페이지로 이동 후에도 setInterval 이 남는 것 방지
  beforeDestroy() {
    if (this.roundCancel.refreshTimerId) {
      clearInterval(this.roundCancel.refreshTimerId);
      this.roundCancel.refreshTimerId = null;
    }
    if (this.betOrders.refreshTimerId) {
      clearInterval(this.betOrders.refreshTimerId);
      this.betOrders.refreshTimerId = null;
    }
  },
};
</script>

<style scoped>
.round-info-table {
  width: 100%;
  font-size: 12px;
}
.round-info-table th {
  text-align: left;
  width: 110px;
  color: #555;
  font-weight: 500;
  padding: 3px 8px 3px 0;
  vertical-align: top;
  white-space: nowrap;
}
.round-info-table td {
  padding: 3px 0;
  font-family: 'D2Coding', 'Menlo', monospace;
  word-break: break-all;
}
</style>
